/**
 * O passo «Onde quer receber?», entre o carrinho e o pedido enviado.
 *
 * O botão de confirmar do webshop chama `request_for_quotation` e submete o
 * orçamento à primeira. Aqui apanhamos o clique ANTES dele, na fase de
 * captura, e mostramos um painel com duas perguntas. Só depois se envia.
 *
 * Porquê interceptar em vez de substituir o template: o botão vive num
 * ficheiro do webshop que continua a receber correcções deles. Interceptar
 * deixa-nos mudar o comportamento sem ficar donos do HTML — é a mesma
 * técnica que o carrinho de visitante já usa.
 *
 * Duas perguntas e não um formulário de morada: em Luanda, quem procura uma
 * casa pergunta o bairro e um ponto conhecido. Rua e número raramente ajudam.
 */
(function () {
	"use strict";

	var PAINEL = "ct-entrega";

	function html() {
		return (
			'<div class="ct-entrega" id="' + PAINEL + '">' +
			'  <h3 class="ct-entrega-titulo">' + __("Onde quer receber?") + "</h3>" +
			'  <p class="ct-entrega-nota">' +
			__("A entrega e a taxa são combinadas por WhatsApp — a taxa depende do bairro.") +
			"</p>" +
			'  <label class="ct-entrega-campo">' +
			"    <span>" + __("Bairro") + "</span>" +
			'    <input type="text" id="ct-bairro" maxlength="140" autocomplete="address-level3"' +
			'           placeholder="' + __("Ex.: Samba, Zamba 2") + '" required>' +
			"  </label>" +
			'  <label class="ct-entrega-campo">' +
			"    <span>" + __("Ponto de referência") + ' <em>' + __("(opcional)") + "</em></span>" +
			'    <textarea id="ct-referencia" rows="2" maxlength="500"' +
			'              placeholder="' + __("Ex.: junto à Igreja Universal") + '"></textarea>' +
			"  </label>" +
			'  <p class="ct-entrega-erro" hidden></p>' +
			'  <div class="ct-entrega-accoes">' +
			'    <button type="button" class="ct-btn ct-btn-linha" data-entrega-voltar>' + __("Voltar") + "</button>" +
			'    <button type="button" class="btn btn-primary" data-entrega-enviar>' + __("Enviar pedido") + "</button>" +
			"  </div>" +
			"</div>"
		);
	}

	function mostrarErro(texto) {
		var p = document.querySelector("#" + PAINEL + " .ct-entrega-erro");
		if (!p) return;
		p.textContent = texto;
		p.hidden = !texto;
	}

	function abrir(botaoOriginal) {
		if (document.getElementById(PAINEL)) return;

		var caixa = botaoOriginal.closest(".frappe-card") || botaoOriginal.parentElement;
		caixa.insertAdjacentHTML("beforeend", html());

		var painel = document.getElementById(PAINEL);
		var bairro = painel.querySelector("#ct-bairro");
		bairro.focus();

		painel.querySelector("[data-entrega-voltar]").addEventListener("click", function () {
			painel.remove();
		});

		painel.querySelector("[data-entrega-enviar]").addEventListener("click", function (e) {
			var botao = e.currentTarget;
			var valor = bairro.value.trim();
			if (!valor) {
				mostrarErro(__("Diga-nos o bairro onde quer receber."));
				bairro.focus();
				return;
			}
			mostrarErro("");
			botao.disabled = true;

			frappe.call({
				method: "cybershop.carrinho.entrega.confirmar",
				type: "POST",
				args: {
					bairro: valor,
					referencia: painel.querySelector("#ct-referencia").value.trim(),
				},
				callback: function (r) {
					if (r.message && r.message.nome) {
						// `/quotations/`, não `/orders/`.
						//
						// O documento que se acabou de submeter é um ORÇAMENTO
						// (`SAL-QTN-...`), e o `/orders/` serve encomendas —
						// dava 404 com o pedido criado na mesma. O cliente
						// enviava, via uma página de erro, e ficava sem saber
						// se tinha comprado. Apanhado a percorrer o caminho
						// completo, não a ler o código.
						window.location.href = "/quotations/" + encodeURIComponent(r.message.nome);
					} else {
						botao.disabled = false;
						mostrarErro(__("Não foi possível enviar. Tente outra vez."));
					}
				},
				error: function () {
					botao.disabled = false;
					mostrarErro(__("Não foi possível enviar. Tente outra vez."));
				},
			});
		});
	}

	document.addEventListener(
		"click",
		function (e) {
			var botao = e.target.closest(".btn-request-for-quotation");
			if (!botao) return;
			// Trava o handler do webshop, que submetia já.
			e.preventDefault();
			e.stopPropagation();
			e.stopImmediatePropagation();
			abrir(botao);
		},
		true // captura: corre antes do webshop
	);
})();
